/* import Moment from "moment";
import 'moment/locale/es'; */
import axios from "axios"
import {getHours, getMonth, getDate, getDay} from 'date-fns'
let week = [6,0,1,2,3,4,5]
export default class TagFunctions {
  static evPageViewPush = async (pageName) => {
    let country;
    try {
      let res = await axios.get("https://extreme-ip-lookup.com/json/") //this request can be block by some adblockers
      country = res.data.country
    } catch (e) {
      country = "NA";
      //console.log(`Can't connect to backend try latter`);
    }
    
    let lang = window.navigator.language.toLowerCase().startsWith('es') ? 'ESP' : 'ENG'
    //Moment.locale('es')
    //const today = Moment();
    const today = new Date()
    var loc = window.location;

    let digitalData = {
      event: "evPageView",
      version: "1.0",
      page: {
        pageInfo: {
          hostName: `${loc.origin}`,
          pageName: `${pageName}`,
          currentURL: `${loc.href}`
        }
      },
      user: {
        profile: {
          userWeekDay: `${week[getDay(today)]}`,
          userMonthDay: `${getDate(today)}`,
          userMonth: `${getMonth(today)+1}`,
          userTime: `${getHours(today)}`,
          languajeUser: lang,
          profileInfo: {
            ageUserBirthYear: sessionStorage.getItem('ageUserBirthYear')?sessionStorage.getItem('ageUserBirthYear'):'NA',
            ageUser: sessionStorage.getItem('ageUser')?sessionStorage.getItem('ageUser'):'NA',
            ageUserCountry: sessionStorage.getItem('ageUserCountry')?sessionStorage.getItem('ageUserCountry'):'NA',
            userId: 'NA',
            email: 'NA',
            login_type: sessionStorage.getItem('login_type')?sessionStorage.getItem('login_type'):'Normal'
          },
          social: {
            network: sessionStorage.getItem('network')?sessionStorage.getItem('network'):'Normal'
          }
        }
      }
    };
    window.dataLayer.push(digitalData);
  };

  static evAgeGatePush = (action, error = 'NA') => {
      window.dataLayer.push({
        action: `${action}`,
        error: `${error}`,
        event: "evAgeGate"
      });
  };

  static evClickOptionsPush = action => {
    window.dataLayer.push({
      actionClick: `${action}`,
      event: "evClickOptions"
    });
  };

  static evSocialNetworkPush = (socialNetwork, action) => {
    window.dataLayer.push({
      socialNetworkName: `${socialNetwork}`,
      actionSocialNetwork: `${action}`,
      event: "evSocialNetwork"
    });
  };

  static evib2cOutboundlinkPush = (name, tipo )=> {
    window.dataLayer.push({
      nameOutboundLinkib2C: `${name}`,
      nameOutboundLinkTypeib2C: `${tipo}`,
      event: "evib2cOutboundlink"
    });
  };

  static evVideoPush = (name, action, quartile, time, pageName) => {
    window.dataLayer.push({
      videoName: `${name}`,
      videoAction: `${action}`,
      videoQuartile: `${quartile}`,
      videototalTime: `${time}`,
      videoCategory: `${pageName}`,
      event: "evVideoEvent"
    });
  };
}